// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__SLxlU","footer":"styles_footer__8iqav"};